import { render, staticRenderFns } from "./CustomTagsAndFields.vue?vue&type=template&id=a59f3010&"
import script from "./CustomTagsAndFields.vue?vue&type=script&lang=js&"
export * from "./CustomTagsAndFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports